import { render, staticRenderFns } from "./AddReturnDispatchLinesModal.vue?vue&type=template&id=b0b950ae&scoped=true&"
import script from "./AddReturnDispatchLinesModal.vue?vue&type=script&lang=js&"
export * from "./AddReturnDispatchLinesModal.vue?vue&type=script&lang=js&"
import style0 from "./AddReturnDispatchLinesModal.vue?vue&type=style&index=0&id=b0b950ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b950ae",
  null
  
)

export default component.exports